/**
 * 弹窗上下文管理
 *
 * 这个文件负责管理全局弹窗的显示和隐藏，包括：
 * - 弹窗元素管理
 * - 弹窗打开/关闭控制
 * - 编辑状态管理
 */

import React, { createContext, useState } from 'react'

/**
 * 弹窗上下文类型定义
 */
interface PopUpContextType {
  /** 打开弹窗 */
  openPopUp: (popUpElement: JSX.Element) => void
  /** 关闭弹窗 */
  closePopUp: () => void
  /** 设置关闭编辑状态 */
  setCloseEdit: (value: string) => void
  /** 关闭编辑状态 */
  closeEdit: string
}

// 创建弹窗上下文
export const PopUpContext = createContext<PopUpContextType>({
  openPopUp: (popUpElement: JSX.Element) => {},
  closePopUp: () => {},
  setCloseEdit: (value: string) => {},
  closeEdit: ''
})

/**
 * 弹窗提供者组件属性
 */
interface PopUpProviderProps {
  children: React.ReactNode
}

/**
 * 弹窗提供者组件
 *
 * @param children - 子组件
 * @returns 提供弹窗相关状态和方法的上下文提供者
 */
const PopUpProvider = ({ children }: PopUpProviderProps) => {
  const [popUpElements, setPopUpElements] = useState<JSX.Element[]>([])
  /**
   * 打开弹窗
   * @param element - 要显示的弹窗元素
   */
  const openPopUp = (element: JSX.Element) => {
    setPopUpElements(prevPopUps => [element, ...prevPopUps])
  }
  /* 
  关闭弹窗
  设置关闭编辑状态
  @param value - 关闭编辑状态
  */
  const closePopUp = () => {
    setPopUpElements(prevPopUps => prevPopUps.slice(1))
  }
  /* 
  关闭编辑状态
  @param value - 关闭编辑状态
  */
  const [closeEdit, setCloseEdit] = useState('')

  return (
    <PopUpContext.Provider value={{ openPopUp, closePopUp, closeEdit, setCloseEdit }}>
      {children}
      {popUpElements[0]}
    </PopUpContext.Provider>
  )
}

export default PopUpProvider
